import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_NODE: `${cleanedFilename(__filename)}-add-node`,
};
